import React from "react";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <section className="w-full lg:w-11/12x bg-red-700x h-full flex items-center justify-center relative">
      <div className="w-11/12x w-10/12 bg-yellow-300x relative z-40">
        <div className="lg:w-2/3 sm:w-3/4x w-full bg-teal-700x items-center md:items-start relative z-40 flex flex-col">
          <p className="text-xs text-white/60 tracking-widest sm:tracking-[.5rem] mb-3 uppercase font-medium">
            New product
          </p>
          <h1 className="text-3xl sm:text-[3rem] bg-yellow-500x sm:leading-[3.5rem] md:text-start text-center font-bold mb-4 sm:mb-2">
            XX99 MARK II HEADPHONES
          </h1>
          <p className="text-xs text-white/90 bg-fuchsia-600x sm:font-medium mb-6 sm:mb-4 tracking-wide md:w-7/12 leading-5 w-2/3 text-center md:text-start">
            Experience natural, lifelike audio and exceptional build quality
            made for the passionate music enthusiast.
          </p>
          <Link
            to="product/XX99-MARK-II"
            className="bg-primary w-max hover:bg-white hover:text-primary text-xs px-6 py-3 font-semibold uppercase tracking-wide"
          >
            See Product
          </Link>
        </div>
      </div>
      <div className="w-full bg-hero bg-cover bg-center hidden h-full absolute right-0 md:flex items-center justify-end "></div>
    </section>
  );
}

export default Hero;
